// import React from 'react';

// const Loader = ({ show }) => {
//   const loaderContainerStyle = {
//     position: 'fixed',
//     top: '0',
//     left: '0',
//     width: '100%',
//     height: '100%',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     backdropFilter: 'blur(1px)',
//     backgroundColor: 'rgba(255, 255, 255, 0.7)',
//     zIndex: '9999',
//   };

//   const spinnerStyle = `
//     @keyframes ldio-v7qr56rxkx {
//       0% { transform: rotate(0) }
//       100% { transform: rotate(360deg) }
//     }
//     .ldio-v7qr56rxkx div { box-sizing: border-box!important }
//     .ldio-v7qr56rxkx > div {
//       position: absolute;
//       width: 62px;
//       height: 62px;
//       top: 19px;
//       left: 19px;
//       border-radius: 50%;
//       border: 8px solid #000;
//       border-color: #5be1d8 transparent #5be1d8 transparent;
//       animation: ldio-v7qr56rxkx 1.2195s linear infinite;
//     }

//     .ldio-v7qr56rxkx > div:nth-child(2), .ldio-v7qr56rxkx > div:nth-child(4) {
//       width: 44px;
//       height: 44px;
//       top: 28px;
//       left: 28px;
//       animation: ldio-v7qr56rxkx 1.2195s linear infinite reverse;
//     }
//     .ldio-v7qr56rxkx > div:nth-child(2) {
//       border-color: transparent #c1b5aa transparent #c1b5aa
//     }
//     .ldio-v7qr56rxkx > div:nth-child(3) { border-color: transparent }
//     .ldio-v7qr56rxkx > div:nth-child(3) div {
//       position: absolute;
//       width: 100%;
//       height: 100%;
//       transform: rotate(45deg);
//     }
//     .ldio-v7qr56rxkx > div:nth-child(3) div:before, .ldio-v7qr56rxkx > div:nth-child(3) div:after { 
//       content: "";
//       display: block;
//       position: absolute;
//       width: 8px;
//       height: 8px;
//       top: -8px;
//       left: 19px;
//       background: #5be1d8;
//       border-radius: 50%;
//       box-shadow: 0 54px 0 0 #5be1d8;
//     }
//     .ldio-v7qr56rxkx > div:nth-child(3) div:after {
//       left: -8px;
//       top: 19px;
//       box-shadow: 54px 0 0 0 #5be1d8;
//     }

//     .ldio-v7qr56rxkx > div:nth-child(4) { border-color: transparent; }
//     .ldio-v7qr56rxkx > div:nth-child(4) div {
//       position: absolute;
//       width: 100%;
//       height: 100%;
//       transform: rotate(45deg);
//     }
//     .ldio-v7qr56rxkx > div:nth-child(4) div:before, .ldio-v7qr56rxkx > div:nth-child(4) div:after {
//       content: "";
//       display: block;
//       position: absolute;
//       width: 8px;
//       height: 8px;
//       top: -8px;
//       left: 10px;
//       background: #c1b5aa;
//       border-radius: 50%;
//       box-shadow: 0 36px 0 0 #c1b5aa;
//     }
//     .ldio-v7qr56rxkx > div:nth-child(4) div:after {
//       left: -8px;
//       top: 10px;
//       box-shadow: 36px 0 0 0 #c1b5aa;
//     }
//     .loadingio-spinner-double-ring-wpqdwpkyq48 {
//       width: 70px;
//       height: 70px;
//       display: inline-block;
//       overflow: hidden;
//       background: none;
//     }
//     .ldio-v7qr56rxkx {
//       width: 100%;
//       height: 100%;
//       position: relative;
//       transform: translateZ(0) scale(0.7);
//       backface-visibility: hidden;
//       transform-origin: 0 0;
//     }
//     .ldio-v7qr56rxkx div { box-sizing: content-box!important; }
//   `;

//   return show && (
//     <div>
//       <style>{spinnerStyle}</style>
//       <div style={loaderContainerStyle}>
//         <div class="loadingio-spinner-double-ring-wpqdwpkyq48">
//           <div class="ldio-v7qr56rxkx">
//             <div></div>
//             <div></div>
//             <div>
//               <div></div>
//             </div>
//             <div>
//               <div></div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Loader;
import React from 'react';

const Loader = ({ show }) => {
  const loaderContainerStyle = {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backdropFilter: 'blur(1px)',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    zIndex: '9998',
  };

  const spinnerStyle = `
  .loader {
    width: 50px;
    aspect-ratio: 1;
    display: grid;
    -webkit-mask: conic-gradient(from 15deg, #21cdc0, #0000);
    animation: l26 1s infinite steps(12);
  }
  .loader,
  .loader:before,
  .loader:after {
    background:
      radial-gradient(closest-side at 50% 12.5%, #21cdc0 96%, #0000) 50% 0/20% 80% repeat-y,
      radial-gradient(closest-side at 12.5% 50%, #21cdc0 96%, #0000) 0 50%/80% 20% repeat-x;
  }
  .loader:before,
  .loader:after {
    content: "";
    grid-area: 1/1;
    transform: rotate(30deg);
  }
  .loader:after {
    transform: rotate(60deg);
  }

  @keyframes l26 {
    100% { transform: rotate(1turn) }
  }
`;

  return show && (
    <div>
      <style>{spinnerStyle}</style>
      <div style={loaderContainerStyle}>

        <div className="loader"></div>
      </div>
    </div>
  );
}

export default Loader;

